module.exports = __webpack_public_path__ + "img/airbase-stage_3.4.86ce82eb.jpg";